export default "__VITE_ASSET__CQh0Fqp8__"